import { Component } from '@angular/core';

@Component({
  selector: 'cva-standalone-page-not-found',
  standalone: false,
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent {

}
